import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CambiarEstadoCancion, songList } from "../../Servicios/Servicios";
import { QRCode } from "react-qrcode-logo";
import qrCodeImage from "../../assets/image/qr_code_2.png";
import AutoScrollText from "../../Component/AutoScrollText/AutoScrollText";
import { useSpinner } from "../../Component/spinner/spinner";

const Music = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const evento = location.state?.evento;

  const playNextSongRef = useRef(null);
  const songsRef = useRef([]);

  const [cerrando, setCerrando] = useState(false);
  const [play, setplay] = useState(true);

  const [songs, setSongs] = useState([]);
  const [InfoEvento, setInfoEvento] = useState(null);
  const [typeListado, setTypeListado] = useState(true);
  const [valorQR, setValorQR] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showModalqr, setShowModalqr] = useState(false);
  const [loadingSongs, setLoadingSongs] = useState(false);
  const spinner = useSpinner();
  const playerRef = useRef(null);
  const intervalRef = useRef(null);

  /** 🔹 Inicialización */
  useEffect(() => {

    if (!evento) {
      navigate("/Eventos");
      return;
    }

    setValorQR(
      `${process.env.REACT_APP_PAGE || "https://eventorys.web.app/"}BuscarCancion/${evento.id}`
    );

    loadYouTubeAPI();
    getSongDetails(evento);
    setInfoEvento(evento);

    // Refresca canciones cada 10s
    intervalRef.current = setInterval(() => {
      getSongDetails(evento);
    }, 10000);

    // Limpieza
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [evento]);
  // 2. Sincronizar songs con el ref
  useEffect(() => {
    songsRef.current = songs;
  }, [songs]);

  /** 🔹 Modal QR */
  const openModalqr = (state) => setShowModalqr(state);

  /** 🔹 Carga única de la API de YouTube */
  const loadYouTubeAPI = () => {
    if (window.YT && window.YT.Player) return; // evita recarga

    const tag = document.createElement("script");
    tag.src = "https://www.youtube.com/iframe_api";
    document.body.appendChild(tag);

    window.onYouTubeIframeAPIReady = () => {
      console.log("YouTube API lista ✅");
    };
  };

  /** 🔹 Obtener lista de canciones */
  const getSongDetails = async () => {
    if (loadingSongs || !evento) return;
    setLoadingSongs(true);
    try {
      console.log("Cargando canciones para el evento:", evento.id);
      const form = { idEvento: evento.id };
      const responseSong = await songList(form);
      if (responseSong.success) {
        setSongs(responseSong.data.resultados || []);
      } else {
        console.warn("No se pudieron obtener canciones");
      }
    } catch (error) {
      console.error("Error al obtener canciones:", error);
    } finally {
      setLoadingSongs(false);
    }
  };

  /** 🔹 Cierre de evento */
  const closeEvent = () => {
    setCerrando(true);
    setTimeout(() => navigate("/Eventos"), 400);
  };

  /** 🔹 Extraer ID de YouTube */
  const extractYouTubeId = (url) => {
    if (!url) return null;
    const regex =
      /(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const match = url.match(regex);
    return match ? match[1] : null;
  };

  /** 🔹 Reproducir canción */
  // const playSong = (index) => {
  //   setplayFunction(true);
  //   if (!songs[index]) return;

  //   setCurrentIndex(index);

  //   const videoId = extractYouTubeId(songs[index].linkReproductor);
  //   if (!videoId) {
  //     console.warn("⚠️ Canción inválida, saltando...");
  //     playNextSong();
  //     return;
  //   }

  //   // Si el reproductor ya existe → solo carga el nuevo video
  //   if (playerRef.current && playerRef.current.loadVideoById) {
  //     playerRef.current.loadVideoById(videoId);
  //   } else if (window.YT && window.YT.Player) {
  //     playerRef.current = new window.YT.Player("youtube-player", {
  //       height: "100%",
  //       width: "100%",
  //       videoId,
  //       playerVars: { autoplay: 1, modestbranding: 1, rel: 0, showinfo: 0, disablekb: 1, controls: 0 },
  //       events: { onStateChange: onPlayerStateChange },
  //     });
  //   } else {
  //     console.warn("⏳ API de YouTube no está lista aún");
  //   }
  // };

  const playSong = (index) => {
  setplay(true);
  if (!songsRef.current[index]) return; // ← usar ref

  setCurrentIndex(index);
  const videoId = extractYouTubeId(songsRef.current[index].linkReproductor);
  
  if (!videoId) {
    console.warn("⚠️ Canción inválida, saltando...");
    playNextSongRef.current();
    return;
  }

  if (playerRef.current?.loadVideoById) {
    playerRef.current.loadVideoById(videoId);
  } else if (window.YT?.Player) {
    playerRef.current = new window.YT.Player("youtube-player", {
      height: "100%",
      width: "100%",
      videoId,
      playerVars: { autoplay: 1, modestbranding: 1, rel: 0, showinfo: 0, disablekb: 1, controls: 0 },
      events: { 
        onStateChange: (e) => playNextSongRef.current && onPlayerStateChange(e) // ← ref
      },
    });
  }
};

  const deleteSont = async (id)=>{
    spinner.show();
    const bodyFinalizarSon = {
       "idLista": id,
       "estadoCancion": "Finalizada"
    }
    const response = await CambiarEstadoCancion(bodyFinalizarSon);
    if (response.success){
      alert("Canción finalizada correctamente");
      getSongDetails();
      spinner.hide();
      
    }else{
      alert("Error al finalizar la canción: " + response.message);
      console.warn("No se pudo finalizar la canción");
      spinner.hide();
    }
  }
  const deleteSong = async (id) => {
  try {
    const body = { idLista: id, estadoCancion: "Finalizada" };
    const response = await CambiarEstadoCancion(body);
    if (response.success) {
      // console.log("✅ Canción marcada como finalizada");
      getSongDetails(); // refresca la lista visual
    } else {
      console.warn("No se pudo finalizar la canción:", response.message);
    }
  } catch (error) {
    console.error("Error al finalizar canción:", error);
  }
};

  const setplayFunction =() =>{
    setplay(!play);
  }
  const changeListType = () => {
    setTypeListado(!typeListado);
  }
  /** 🔹 Pausar canción */
  const pauseVideo = () => {
    setplayFunction(false);
    playerRef.current?.pauseVideo();
  };

  /** 🔹 Reanudar canción */
  const resumeVideo = () => {
    setplayFunction(true);
    playerRef.current?.playVideo();
  };

  /** 🔹 Siguiente canción */
// const playNextSong = () => {
//   setCurrentIndex((prevIndex) => {
//     const nextIndex = prevIndex + 1;

//     if (nextIndex < songs.length) {
//       console.log("➡️ Siguiente canción:", nextIndex);
//       playSong(nextIndex);
//       return nextIndex;
//     } else {
//       console.log("✅ Playlist finalizada");
//       return prevIndex;
//     }
//   });
// };
const playNextSong = () => {
  setCurrentIndex((prevIndex) => {
    const nextIndex = prevIndex + 1;
    if (nextIndex < songsRef.current.length) {
      console.log("➡️ Siguiente canción:", nextIndex);
      playSong(nextIndex);
      return nextIndex;
    } else {
      console.log("✅ Playlist finalizada");
      return prevIndex;
    }
  });
};

useEffect(() => {
  playNextSongRef.current = playNextSong;
});
const currentIndexRef = useRef(0);

// Sincronizar con el estado
useEffect(() => {
  currentIndexRef.current = currentIndex;
}, [currentIndex]);

  /** 🔹 Canción anterior */
const playPreviousSong = () => {
  setCurrentIndex((prevIndex) => {
    const prev = prevIndex - 1;
    if (prev >= 0) {
      playSong(prev);
      return prev;
    }
    return prevIndex;
  });
};

//   /** 🔹 Evento de cambio de estado del reproductor */
// const onPlayerStateChange = (event) => {
//   const YTState = window.YT?.PlayerState;

//   if (event.data === YTState.ENDED) {
//     console.log("🎶 Canción terminada, pasando a la siguiente...");
//     playNextSong();
//   } else if (event.data === YTState.PLAYING) {
//     console.log("▶️ Reproduciendo...");
//   } else if (event.data === YTState.PAUSED) {
//     console.log("⏸️ Pausado");
//   }
// };
  const onPlayerStateChange = (event) => {
    const YTState = window.YT?.PlayerState;
    if (event.data === YTState.ENDED) {
      console.log("🎶 Canción terminada, pasando a la siguiente...");

      // Eliminar la canción actual antes de pasar a la siguiente
    const currentSong = songsRef.current[currentIndexRef.current]; // ← necesitas este ref
    if (currentSong?.id) {
      deleteSong(currentSong.id);
    }
      playNextSongRef.current(); // ← aquí el cambio clave
    } else if (event.data === YTState.PLAYING) {
      console.log("▶️ Reproduciendo...");
    } else if (event.data === YTState.PAUSED) {
      console.log("⏸️ Pausado");
    }
  };
  // Ref para el scroll automático
  const activeSongRef = useRef(null);

  // Scroll automático cuando cambia currentIndex
  useEffect(() => {
    activeSongRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
  }, [currentIndex]);

  return (
    <div className="h-full w-full">
      {/* Modal QR */}
      {showModalqr && (
        <div
          className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
          onClick={() => setShowModalqr(false)}
        >
          <div
            className="p-4 rounded-lg shadow-lg inline-block relative"
            id="CuadrosEstandarColor"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => openModalqr(false)}
              className="absolute top-3 right-3 text-gray-500 hover:text-black text-xl"
            >
              ×
            </button>
            <h2 className="text-xl font-bold mb-4 text-center text-white">Código QR Evento</h2>
            <div className="mt-4 flex justify-center">
              <QRCode value={valorQR} fgColor="#293d9aff" size={256} />
            </div>
          </div>
        </div>
      )}

      <div className="p-2 rounded-xl w-full max-w-full md:max-w-[100%] md:h-[95%] mx-2 md:mx-auto mt-4" id="CuadrosEstandarColor">
        <div className="overflow-x-auto">
          <div className="grid grid-cols-[60%_40%] gap-4 min-w-[600px]">
            <div className="p-4">
              {/* Header */}
              <div className="flex border-b pb-2 w-full">
                <div className="grid grid-cols-1 w-full gap-0">
                  {/* Reproductor */}
                  <div className="w-full h-[100px]">
                    <button
                        className={`bg-red-500 text-white px-6 py-3 rounded transition-all duration-300 ${
                          cerrando ? "scale-0 opacity-0" : "scale-100 opacity-100"
                        }`}
                        onClick={closeEvent}
                        >
                      ✕
                    </button>
                  </div>
                  
                  <div className="w-full h-[300px]">
                    <div id="youtube-player"></div>
                  </div>

                </div>
              </div>

              {/* Controles */}
              <div className="flex justify-center gap-4 mt-3">
                <button
                  className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-2 rounded-full text-sm"
                  onClick={playPreviousSong}
                >
                  ⏮
                </button>
                {play ? (

                  <button
                    className={`text-white px-3 py-2 rounded-full text-sm transition-all duration-200 ${
                      play
                        ? "bg-yellow-500 hover:bg-yellow-600"
                        : "bg-green-500 hover:bg-green-600"
                    }`}
                    onClick={() => (play ? pauseVideo() : resumeVideo())}
                  >
                    {play ? "⏸" : "▶"}
                  </button>
                ): (
                  <button
                    className="bg-yellow-500 hover:bg-yellow-600 text-white px-3 py-2 rounded-full text-sm"
                    onClick={pauseVideo}
                  >
                    ⏸
                  </button>
                )}
                <button
                  className="bg-purple-500 hover:bg-purple-600 text-white px-3 py-2 rounded-full text-sm"
                  onClick={playNextSong}
                >
                  ⏭
                </button>
                <div
                  className="flex items-center cursor-pointer justify-center w-10 h-10 rounded-md"
                  style={{ backgroundColor: "#4F60A8BA" }}
                  onClick={() => openModalqr(true)}
                >
                  <img src={qrCodeImage} alt="QR Code" />
                </div>
              </div>

            </div>
            <div className="p-4">

              
              <div className="w-[95%] h-[80%]">

                {/* Descripción */}
                <div className="border-b py-2 text-xs text-white mb-4">
                  <p>{InfoEvento?.nombreEvento}</p>
                  <p>{InfoEvento?.horarios}</p>
                </div>
                <div className="flex items-center gap-4">
                  <h3 className={`text-sm  mb-2 rounded pl-2 pr-2 text-white cursor-pointer ${typeListado === true ? 'font-semibold' :'' }` } onClick={()=>changeListType()} id="CuadrosEstandarColor" >Playlist Generada</h3>
                  <h3 className={`text-sm  mb-2 rounded pl-2 pr-2 text-white cursor-pointer ${typeListado !== true ?'font-semibold' :'' }`} onClick={()=> changeListType()} id="CuadrosEstandarColor" >Playlist Reproducida</h3>
                </div>
                { typeListado ? (

                  <div className="flex flex-col overflow-y-auto overflow-x-hidden max-h-[60vh]">
                    {songs.length > 0 ? (
                      songs.map(
                        (song, index) =>
                          song.estadoCancion !== "Finalizada" && (
                            <div
                              key={index}
                              ref={index === currentIndex ? activeSongRef : null}
                              id="CuadrosEstandarColor"
                              className={`flex items-center justify-between rounded-md w-[98%] mb-2 p-2 transition-all duration-300 ${
                                index === currentIndex 
                                  ? "border-2 border-green-400 shadow-[0_0_10px_#4ade80] scale-[1.02]" 
                                  : "opacity-70"
                              }`}
                            >
                              <div className="flex items-center gap-2 w-[80%]">
                                {song.linkFotoCancion && (
                                  <img
                                    src={song.linkFotoCancion}
                                    alt="Song"
                                    className="w-12 h-12 rounded-md"
                                  />
                                )}

                                <div className="flex flex-col overflow-hidden w-full">
                                  {/* <span className="marquee text-xs text-gray-800">
                                    {song.nombreCancion}
                                  </span>*/}
                                  <AutoScrollText>{song.nombreCancion}</AutoScrollText>
                                  <span className="marquee text-xs text-white">
                                    {song.artista}
                                  </span> 
                                  
                                </div>
                              </div>

                              <div className="flex gap-1">
                                <button
                                  className={`text-white px-2 py-1 rounded-full text-xs transition-all duration-200 ${
                                    index === currentIndex && play
                                      ? "bg-yellow-500 hover:bg-yellow-600"
                                      : "bg-green-500 hover:bg-green-600"
                                  }`}
                                  onClick={() => {
                                    if (index === currentIndex) {
                                      // Misma canción → toggle play/pause
                                      play ? pauseVideo() : resumeVideo();
                                    } else {
                                      // Otra canción → reproducir
                                      playSong(index);
                                    }
                                  }}
                                >
                                  {index === currentIndex && play ? "⏸" : "▶"}
                                </button>
                                <button
                                  className="bg-red-500 hover:bg-red-600 text-white px-2 py-1 rounded-full text-xs"
                                  onClick={() => deleteSont(song.id)}
                                >
                                  🗑️
                                </button>
                              </div>
                            </div>
                          )
                      )
                    ) : (
                      <p className="text-xs text-gray-500">No hay canciones en la playlist.</p>
                    )}
                  </div>
                ):(
                  <div className="flex flex-col w-[100%] overflow-y-auto overflow-x-hidden max-h-[60vh]">
                    {songs.length > 0 ? (
                      songs.map(
                        (song, index) =>
                          song.estadoCancion !== "reproduciendo" && (
                            <div
                              key={index}
                              id="CuadrosEstandarColor"
                              className={`flex items-center justify-between rounded-md w-[98%] mb-2 p-2 ${
                                index === currentIndex ? "bg-green-100" : ""
                              }`}
                            >
                              <div className="flex items-center gap-2 w-[98%]">
                                {song.linkFotoCancion && (
                                  <img
                                    src={song.linkFotoCancion}
                                    alt="Song"
                                    className="w-12 h-12 rounded-md"
                                  />
                                )}
                                <div className="flex flex-col">
                                  <span className="text-xs text-white truncate">{song.nombreCancion}</span>
                                  <span className="text-xs text-gray-300 truncate">{song.artista}</span>
                                </div>
                              </div>

                              <div className="flex gap-2">
                                <button
                                  className="bg-green-500 hover:bg-green-600 text-white px-2 py-1 rounded-full text-xs"
                                  onClick={() => playSong(index)}
                                >
                                  +
                                </button>
                              </div>
                            </div>
                          )
                      )
                    ) : (
                      <p className="text-xs text-gray-500">No hay canciones en la playlist.</p>
                    )}
                  </div>
                )

                }

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Music;
